import React, { useContext, useState, useEffect } from "react";
import { ImWarning } from "react-icons/im";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
import {AuthContext} from '../services/Session/Context';
import {FirebaseContext} from '../services/Firebase/Context';
import FeedbacksItem from './FeedbacksItem';

const FeedbacksCard = () => {
  const { user } = useContext(AuthContext);
  const { db } = useContext(FirebaseContext);
  const [fb, setFb] = useState([]);

  useEffect(() => {
    if(!user) return
    
    const q = query(collection(db, "feedbacks"), where("organisationId", "==", user.organisationId), orderBy("date", 'desc'), limit(5));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const feedbacks = [];
      querySnapshot.forEach((doc) => {
        feedbacks.push({id: doc.id, ...doc.data()});
      })
      setFb(feedbacks);
    })
    return () => unsubscribe();
  }, [db, user])

  return (
    <div className="shadow-lg rounded-xl w-full p-4 bg-white dark:bg-gray-800 overflow-hidden">
      <div className="w-full flex items-center justify-between mb-8">
        <p className="text-gray-800 dark:text-white text-xl font-normal">
            Retours client
        </p>
        {/*<a href="#" className="flex items-center text-sm hover:text-gray-600 dark:text-gray-50 dark:hover:text-white text-gray-300 border-0 focus:outline-none">
            VIEW ALL
        </a>
        */}
      </div>
      {
        fb && fb.map((feedback) => <FeedbacksItem key={feedback.id} date={feedback.date} grade={feedback.global} recordId={feedback.recordId} />)
      }
      {
        fb.length === 0 && <div className='text-center'>
          <ImWarning className="h-10 w-10 p-2 mx-auto mb-2 text-yellow-300" />
          <p>Pas de retours enregistrées pour le moment</p>
        </div>
      }
    </div>
  );
}

export default FeedbacksCard
